import { render, staticRenderFns } from "./CCLILogoWhite.vue?vue&type=template&id=9123ffd8&scoped=true"
import script from "./CCLILogoWhite.vue?vue&type=script&lang=ts"
export * from "./CCLILogoWhite.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9123ffd8",
  null
  
)

export default component.exports